<div class="color-line"></div>

<div>
  <div
    id="logo"
    class="light-version lmn-logo-wrapper"
    *ngIf="!isFranchise('GUY')"
  >
    <a
      ><img [src]="'/assets/images/lmn-primary-dark.svg'" style="width: 80px" />
    </a>
  </div>
  <div
    id="logo"
    class="light-version"
    style="padding-top: 5px"
    *ngIf="isFranchise('GUY')"
  >
    <a
      ><img [src]="'assets/images/franchise/gg-pro-logo.svg'" height="40" />
    </a>
  </div>
  <nav role="navigation">
    <div class="header-link" (click)="minimize()">
      <i class="fa fa-bars"></i>
    </div>
    <div class="small-logo">
      <span class="text-primary"><a>LMN</a></span>
    </div>
    <div class="navbar-right">
      <ul class="nav navbar-nav no-borders">
        <li class="dropdown">
          <a (click)="logout()">
            <i class="pe-7s-upload pe-rotate-90"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</div>
